import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import {
  TableRow,
  NameLink,
  TableDetailCell,
  FunnelTypeBadge,
  TableDetailNameCell
} from "../common-styling";
import { ACCESS_CONFIG } from "../strings";
import { useDialog } from "../../hooks/useDialog";
import { hasAccess } from "../../services/access";
import NoResultsRow from "../no-results-table-row";
import { deleteTemplate } from "../../services/api-declaration";
import { generateDateTime } from "../../services/common-service";
import { showError, showSuccess } from "../../services/toast-service";
import { useTranslation } from "react-i18next";

const TempTypeBadge = styled(FunnelTypeBadge)`
  padding: 8px;
  min-width: 40%;
`;

const TemplateTableRow = ({ templates, getTemplates }) => {
  const { t } = useTranslation();
  const { ADMIN_TIER, ONLY_SUPER_ADMIN } = ACCESS_CONFIG;
  const { showConfirmationDialogBox, setDependentStates } = useDialog();
  const toggleDialog = () =>
    showConfirmationDialogBox({
      title: t("common.confirmDeletion"),
      dialogMessage: renderDialogMessage(),
      dialogType: "danger",
      responseAction: dialogResponseAction
    });

  const renderDialogMessage = () => (
    <div dangerouslySetInnerHTML={{ __html: t("deleteTemplateMessage") }}></div>
  );
  const handleDeleteIconClick = (temp) => {
    setDependentStates({ selectedTemp: temp });
    toggleDialog();
  };
  const handleDelete = async (temp) => {
    try {
      const response = await deleteTemplate(temp.id);
      showSuccess(response.data.message);
      await getTemplates();
    } catch (err) {
      console.log(err);
      showError(err.response.data.message || t("toastMessage.deleteTemplate"));
    }
  };
  const dialogResponseAction = async (action, values) => {
    if (action && Object.keys(values.selectedTemp).length) {
      await handleDelete(values.selectedTemp);
    }
  };

  return templates.length ? (
    templates.map((template, index) => (
      <React.Fragment key={index}>
        <TableRow>
          <TableDetailNameCell className="align-middle py-3">
            <NameLink className="d-block" to={`${template.id}`}>
              {template.name}
            </NameLink>
          </TableDetailNameCell>
          <TableDetailCell className="align-middle py-3">
            <TempTypeBadge
              $btnbg={`--${template.templateType.toLowerCase()}-badge-bg`}
              $btncolor={`--${template.templateType.toLowerCase()}-color`}
            >
              {template.templateType.toLowerCase()}
            </TempTypeBadge>
          </TableDetailCell>
          <TableDetailCell className="align-middle py-3">
            {template.updatedAt
              ? generateDateTime(template.updatedAt)
              : generateDateTime(template.createdAt)}
          </TableDetailCell>
          {hasAccess(ADMIN_TIER) && (
            <TableDetailCell className="text-end align-middle py-3">
              <div className="d-flex justify-content-end">
                <Button
                  size="sm"
                  as={Link}
                  variant="outline-primary"
                  className="me-2 rounded-circle"
                  to={template.id}
                >
                  <FontAwesomeIcon size="sm" icon={faPenToSquare} />
                </Button>
                {hasAccess(ONLY_SUPER_ADMIN) && (
                  <Button
                    size="sm"
                    className="rounded-circle"
                    variant="outline-danger"
                    onClick={() => handleDeleteIconClick(template)}
                  >
                    <FontAwesomeIcon size="sm" icon={faTrash} />
                  </Button>
                )}
              </div>
            </TableDetailCell>
          )}
        </TableRow>
      </React.Fragment>
    ))
  ) : (
    <NoResultsRow lengthOfColumns="4" />
  );
};
export default TemplateTableRow;
